import {ShapeComponent, shapeComponent} from "set-state-compare/src/shape-component"
import Button from "components/utils/button"
import {ContactRelationship} from "models"
import {FlashNotifications as FlashMessage} from "flash-notifications"
import memo from "set-state-compare/src/memo"
import Modal from "components/modal"
import PropTypes from "prop-types"
import React from "react"
import {Text} from "shared/base"
import useI18n from "i18n-on-steroids/src/use-i18n.mjs"
import {View} from "react-native"

export default memo(shapeComponent(class ComponentsSchoolClassRolesRemoveRoleModal extends ShapeComponent {
  static propTypes = {
    schoolClassRole: PropTypes.instanceOf(ContactRelationship).isRequired
  }

  setup() {
    const {t} = useI18n({namespace: "js.components.school_class_roles.remove_role_modal"})

    this.t = t
  }

  render() {
    const {t} = this.tt
    const {schoolClassRole, ...restProps} = this.props

    return (
      <Modal {...restProps}>
        <View>
          <Text style={this.areYouSureTextStyle ||= {marginBottom: 30, fontSize: 32, textAlign: "center"}}>
            {t("js.shared.are_you_sure")}
          </Text>
        </View>
        <View>
          <Text style={this.confirmWishTextStyle ||= {marginBottom: 30, fontSize: 20, textAlign: "center"}}>
            {t(".confirm_you_wish_to_remove_the_attachment_to_the_class_for_the_user")}
          </Text>
        </View>
        <View>
          <Text style={this.userNameTextStyle ||= {marginBottom: 30, fontSize: 20, fontWeight: "bold", textAlign: "center"}}>
            {this.p.schoolClassRole.child().user().name()}
          </Text>
        </View>
        <Button
          color="red"
          dataSet={this.yesButtonDataSet ||= {class: "yes-remove-the-person-button"}}
          fontStyle={this.yesButtonFontStyle ||= {fontSize: 20}}
          onPress={this.tt.onRemovePressed}
          style={this.yesButtonStyle ||= {marginBottom: 15}}
          title={t(".yes_remove_the_person_from_the_class")}
        />
        <Button
          color="grey"
          fontStyle={this.goBackButtonStyle ||= {fontSize: 20}}
          onPress={this.tt.onGoBackPressed}
          title={t(".go_back")}
        />
      </Modal>
    )
  }

  onGoBackPressed = () => this.p.onRequestClose()

  onRemovePressed = async () => {
    try {
      await this.p.schoolClassRole.destroy()
      FlashMessage.success(this.t(".the_user_was_removed_from_the_class"))
    } catch (error) {
      FlashMessage.errorResponse(error)
    }
  }
}))
